import Badge from 'client/components/core/Badge'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import BlogContentPlaceholderUi from 'client/components/entities/BlogContentPlaceholder/ui/BlogContentPlaceholderUi'
import { EntityProps } from 'client/types'
import CommonBodyNew from 'common/components/entities/BodyNew'
import { BlogContentPlaceholderInterface } from 'common/types/entities/BlogContentPlaceholderInterface'
import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

function BlogContentPlaceholderNew({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<BlogContentPlaceholderInterface>) {
  const { t } = useTypedTranslation()

  const renderChildren = () => {
    return entity.childIds.length > 0 ? (
      <ChildrenEntities
        id={entity.id}
        isReadOnly={entity.isReadOnly}
        childIds={entity.childIds}
        type={entity.type}
      />
    ) : (
      <>
        <BlogContentPlaceholderUi>
          {t('entities.blog_content_placeholder.placeholder')}
        </BlogContentPlaceholderUi>
        <Badge wide>
          {t('entities.blog_content_placeholder.warnings.do_not_remove')}
        </Badge>
      </>
    )
  }
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonBodyNew
        htmlAttrId={entity.htmlAttrId}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
      >
        {renderChildren()}
      </CommonBodyNew>
    </BaseEntityNew>
  )
}

export default BlogContentPlaceholderNew
